import { render, staticRenderFns } from "./BreadcrumbItem.vue?vue&type=template&id=b7b924f6&scoped=true&"
import script from "./BreadcrumbItem.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbItem.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbItem.vue?vue&type=style&index=0&id=b7b924f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b924f6",
  null
  
)

export default component.exports